module.exports = __webpack_public_path__ + "img/paris.391b1326.png";